import { render } from "./DoiSuccessView.vue?vue&type=template&id=e204ef1e&scoped=true"
import script from "./DoiSuccessView.vue?vue&type=script&lang=js"
export * from "./DoiSuccessView.vue?vue&type=script&lang=js"

import "./DoiSuccessView.vue?vue&type=style&index=0&id=e204ef1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e204ef1e"]])

export default __exports__